import api from './api';

export interface Ruta {
  codigoRuta?: number;
  nombreRuta?: string;
  sincronizar?: number;
}

const rutaService = {
  getRutas: async (): Promise<Ruta[]> => {
    const resp = await api.get('/api/Rutas');
    const data = resp.data;
    if (Array.isArray(data)) return data as Ruta[];
    if (Array.isArray(data?.items)) return data.items as Ruta[];
    return [];
  },
  
  getRuta: async (codigoRuta: number): Promise<Ruta | null> => {
    try {
      const resp = await api.get(`/api/Rutas/${codigoRuta}`);
      return resp.data as Ruta;
    } catch (error) {
      console.error(`Error al obtener ruta ${codigoRuta}:`, error);
      return null;
    }
  },
};

export default rutaService;

